<template>
  <div class="nav-submenu-box">
    <div class="logo_left">
      <!-- <img src="../assets/images/latast_pc/pcLogo_left.png" alt=""> -->
    </div>
    <div>
      <el-menu
        v-show="$route.path !== '/index'"
        class="el-menu-vertical-demo"
        mode="horizontal"
        :unique-opened="true"
        :default-active="this.$route.path"
        @select="selectMenu"
        style="height: 100%;width: 100%;"
      >
        <template v-for="(item, index) of list">
          <el-menu-item
            :index="item.path"
            :key="index"
          >
            <template slot="title"><span :style="item.name == '交易中心' ? 'color:#ccc':''">{{ item.name }}</span></template>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <div class="logo_right">
      <div class="img"><img src="../assets/images/latast_pc/pcLogo_right.png" alt=""></div>
      <div class="txt">sssss</div>
      <div class="icon"><i class="el-icon-arrow-down"></i></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
let clientWidth = document.body.clientWidth
import Config from '@/config/config-1'
export default {
  name: 'MenuListFordark',
  data () {
    return {
      isdark: 'false',
      Menutit: '',
      fordark: true,
      list: [
        {
          name: '减碳行为',
          path: Config.masterGoBackTest+'carbonReduction'
        },
        {
          name: '权益体系',
          path: Config.masterGoBackTest+'rightsAndInterests'
        },
        {
          name: '', // 碳达人·惠湖州
          path: ''
        },
        {
          name: '交易体系',
          path: Config.masterGoBackTest+'tradingSystem'
        },
        {
          name: '绿色基金',
          path: Config.masterGoBackTest+'greenFund'
        },
        // {
        //   name: '首页',
        //   path: '/Home'
        //   // children: [
        //   //     {
        //   //         name: '工业碳监测',
        //   //         path: '/carbonNeutral/carbonMonitoringDark/city/carbonMonitoringGY'
        //   //     },
        //   //     {
        //   //         name: '重点行业碳监测',
        //   //         path: '/carbonNeutral/carbonMonitoringDark/city/carbonMoreIndustry'
        //   //     }
        //   // ]
        // },
      ]
    }
  },
  watch: {
    $route (to, form) {
      if (clientWidth > 750) {
        // if (to.path == '/index') {
        //   this.fordark = false
        // } else {
        //      this.fordark = true
        //    }
        //  else if (to.path == '/Home'||to.path == '/tradingSystem') {
        //   this.fordark = true }
      }
    }
  },
  mounted () {
    // console.log(this.list, 'MenuListFordark')
    // console.log('dark')
    // if (clientWidth > 750) {
    //   if (this.$route.path == '/index') {
    //     this.fordark = false
    //   } else {
    //     this.fordark = true
    //   }
    // }
  },
  methods: {
    selectMenu (key, keyPath) {
      console.log(keyPath)
      console.log(key)
      this.$router.push({
        path: key,
      });
    }
  },
  created () {},
}
</script>

<style lang="scss" scoped>
.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  background-color: transparent;
  background-image: url('../assets/images/latast_pc/nav_act_bgc.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 0 solid #409EFF;
  color: #fff !important;
  background-color: transparent;
  background-image: url('../assets/images/latast_pc/nav_act_bgc.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.nav-submenu-box {
  width: 100%;
  height: 1rem;
  background-image: linear-gradient(180deg, #001632 34%, #064F8B 100%);
  display: flex;
  justify-content: space-between;
  color: #fff;
  box-sizing: border-box;
  .logo_left {
    width: 2rem;
    height: 52px;
    margin-top: .15rem;
    margin-left: .5rem;
    box-sizing: border-box;
    img {
      width: 100%;
    }
  }
  .logo_right {
    display: flex;
    color: #89CEFF;
    margin-top: .25rem;
    margin-right: .5rem;
    box-sizing: border-box;
    .img {
      width: .4rem;
      img {
        width: 100%;
      }
    }
    .txt {
      font-size: .35rem;
      line-height: .4rem;
      margin-left: .15rem;
    }
    .icon {
      font-size: .3rem;
      line-height: .4rem;
      margin-left: .15rem;
    }
  }

  // 中间菜单
  .el-menu {
    background-color: transparent;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 1rem;
    width: 3rem;
    line-height: 1rem;
    text-align: center;
    margin: 0;
    border-bottom: 0;
    color: #89CEFF;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 600;
    font-size: .35rem;
  }
  .el-menu--horizontal>.el-menu-item:nth-child(3) {
    float: left;
    height: 1.15rem;
    width: 8rem;
    line-height: .9rem;
    text-align: center;
    margin: 0;
    border-bottom: 0;
    color: #fff;
    font-family: YouSheBiaoTiHei;
    font-weight: 600;
    font-size: .5rem;
    text-shadow: 0 0 0.135417rem #1492ff;
    background-image: url('../assets/images/latast_pc/nav_center_bgc.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
// /* ------------------  已确定 生效样式  ---------------------- */
// /* 一级菜单的样式  el-menu-item */
// .el-menu--horizontal > div > .el-menu-item {
//   float: left;
//   height: 58px;
//   line-height: 58px;
//   margin: 0;
//   font-size: 20px; /*no*/
//   width: 100px;
//   font-weight: 400 !important;
//   background: transparent; // #003863 !important;
// }
// /* 二级菜单有孩子的 */
// .nav-submenu-box1 /deep/ .darkhoverNoImg .el-submenu__title {
//   background: #003863 !important;
//   height: 48px;
//   line-height: 48px;
//   // color:#1492ff !important;
// }
// .nav-submenu-box1 /deep/ .darkhoverNoImg .el-submenu__title span {
//   color: #1492ff !important;
// }
// .nav-submenu-box1 /deep/ .darkhoverNoImg .el-submenu__title:hover {
//   background: #003863 !important;
//   background-image: none !important;
//   // color: #fff !important;
// }

// /* 一级菜单高亮颜色 */
// .el-menu--horizontal > div > .darkhover.is-active > .el-submenu__title > span {
//   color: #fff !important;
//   font-weight: 500;
//   font-size: 22px;
// }
// /* 二级菜单有孩子的 高亮样式 */
// .nav-submenu-box1 /deep/ .darkhoverNoImg.is-active .el-submenu__title span {
//   color: #fff !important;
//   font-size: 22px;
// }
// .nav-submenu-box1 /deep/ .darkhoverNoImg .el-submenu__title span:hover {
//   color: #fff !important;
// }
// /* 三级菜单有孩子的 高亮样式 */
// .nav-submenu-box1 /deep/ .darkhoverNoImg .darkhoverNoColor .el-submenu__title span {
//   color: #1492ff !important;
//   font-size: 22px;
// }
// .nav-submenu-box1 /deep/ .darkhoverNoImg .darkhoverNoColor span:hover {
//   color: #fff !important;
// }
// /* 二级菜单高亮样式 */
// .nav-submenu-box1 /deep/ .el-menu-item:hover {
//   font-weight: 500 !important;
//   color: #fff !important;
//   background-color: #003863 !important;
// }
// .nav-submenu-box1 /deep/ .el-submenu {
//   text-align: center;
// }
// // /deep/ .el-menu--horizontal .el-menu .el-submenu__title{
// //   background:#003863 !important;
// //   color: #1492ff !important;
// // }
// // 暗底
// #darkhover span {
//   color: #1492ff !important;
// }
// #darkhover.is-active {
//   background-color: transparent !important;
// }
// #darkhover.is-active span {
//   color: #fff !important;
//   font-size: 22px;
//   font-weight: 500;
// }

// /deep/ #darkhover:hover {
//   background: rgba(16, 53, 92, 0.8) !important;
//   color: #fff;
//   // background-image: url("../../assets/images/carbonMonitoringDark/navhover.png") !important;
//   // background-repeat: no-repeat !important;
//   // background-size: 100% 100% !important;
// }

// /deep/ .darkhover .el-submenu__title:hover {
//   background: rgba(16, 53, 92, 0.8) !important;
//   color: #fff;
//   // background-image: url("../../assets/images/carbonMonitoringDark/navhover.png") !important;
//   // background-repeat: no-repeat !important;
//   // background-size: 100% 100% !important;
// }
// .el-menu--horizontal > div > .darkhover > .el-submenu__title > span {
//   color: #1492ff !important;
// }

// .darkhover {
//   background: none !important;
// }
// .darkhover :active {
//   background: none !important;
// }
// .darkhover :hover {
//   background: none !important;
// }

// .isHdarkhover:hover {
//   background: rgba(16, 53, 92, 0.8) !important;
//   color: #fff;
//   // background-image: url("../../assets/images/carbonMonitoringDark/navhover.png") !important;
//   // background-repeat: no-repeat !important;
//   // background-size: 100% 100% !important;
// }

// /*修改ie下导航菜单的样式问题*/
// @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
//   >>> .el-menu-item {
//     text-align: center !important;
//     font-size: 16px;
//   }
//   >>> .el-submenu {
//     text-align: center !important;
//     font-size: 16px;
//   }
//   >>> .is-opened {
//     text-align: center !important;
//     font-size: 16px;
//   }
//   >>> .login-span-color {
//     font-size: 16px;
//   }
// }
// /* ------------------  end  ---------------------- */

// // .nav-submenu-box1 .iconhelp {
// //   display: inline-block;
// //   width: 16px;
// //   height: 16px;
// //   background: url("../../assets/images/home/icon-help.png") center center;
// //   background-size: cover;
// // }
// /* 水平样式 */
// .el-menu--horizontal > div > .el-submenu {
//   float: left;
//   width: 100px;
// }
// .el-menu--horizontal > div > .el-submenu:nth-child(4) {
//   float: left;
//   background: transparent;
// }
// .el-menu--horizontal > div > .el-submenu:nth-child(2) {
//   float: left;
//   background: transparent;
// }
// .el-menu--horizontal > div > .el-submenu:nth-child(1) {
//   background: transparent;
// }
// .el-menu--horizontal > div > .el-submenu:nth-child(3) {
//   background: transparent;
// }
// .el-menu--horizontal > div > .el-submenu:nth-child(5) {
//   background: transparent;
// }
// .el-menu--horizontal > div > .el-submenu.kezaisheng {
//   float: left;
// }

// // .el-menu--horizontal > div > .el-menu-item.lingd {
// //   width: 100px;
// // }
// // 导航条选中状态
// .el-menu--horizontal > div > .el-menu-item.is-active {
//   font-size: 20px; /*no*/
//   font-weight: 500 !important;
//   // background-color: transparent !important;
//   // color: #fff !important;
// }

// // .el-menu--horizontal > div > .el-submenu.is-active .el-submenu__title {
// //   border-bottom: 2px solid #00a65a;
// //   color: #303133;
// // }
// /* 解决下图2 无下拉菜单时 不对齐问题 */
// // .el-menu--horizontal > div > .el-submenu .el-submenu__title {
// //   height: 60px;
// //   line-height: 60px;
// //   // border-bottom: 2px solid transparent;
// //   color: #1d2023;
// //   font-size: 16px;
// // }
// >>> .el-icon-arrow-down:before {
//   content: "";
//   display: none;
// }
// // >>> .el-icon-arrow-right:before {
// //   display: none;
// // }
// /*上边距 */
// .nav-submenu-box1 /deep/ .el-submenu__title {
//   font-size: 20px;
//   text-align: center;
// }
// .nav-submenu-box1 /deep/ .el-menu--popup-bottom-star {
//   margin-top: 0;
// }
// .nav-submenu-box1 /deep/ .el-menu--popup-right-start {
//   margin-right: 0px;
// }
// .nav-submenu-box1 /deep/ .el-menu--popup {
//   box-shadow: none;
//   -webkit-box-shadow: none;
//   padding: 0;
// }
// .nav-submenu-box1 /deep/ .el-menu.el-menu--horizontal {
//   border-bottom: 0;
// }
// .nav-submenu-box1 /deep/ .el-menu-item {
//   font-size: 20px;
//   text-align: center;
// }
// .redPoint {
//   position: relative;
//   &:after {
//     content: "";
//     display: block;
//     position: absolute;
//     top: 0px;
//     right: 0px;
//     width: 6px;
//     height: 6px;
//     background: #ff0034;
//     border-radius: 100%;
//   }
// }


// .el-menu--horizontal > div > .tanjianceHuise > span {
//   color: #1492ff !important;
// }
// .el-menu--horizontal .el-menu .nav-submenu-box1 .tanjianceHuise { 
//   background-color: #003863 !important;
// }
// .el-menu--horizontal .el-menu .nav-submenu-box1 .el-menu-item {
//   background-color: #003863 !important;
//   height: 48px;
//   line-height: 48px;
// }
// .nav-submenu-box1 /deep/ .el-menu--collapse .el-menu .el-submenu,
// .el-menu--popup {
//   min-width: 180px;
// }
// .nav-submenu-box1 /deep/ .el-submenu .el-menu-item {
//   min-width: 180px;
// }
// .nav-submenu-box1 /deep/ .el-menu-item {
//   font-family: "Avenir", Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   text-align: center;
//   font-size: 20px;
//   font-weight: 400 !important;
// }

// /**导航条带有二级菜单的一级菜单 el-submenu__title */
// .nav-submenu-box1 /deep/ .el-submenu__title {
//   font-family: "Avenir", Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   font-size: 20px; /*px*/
//   height: 58px;
//   line-height: 58px;
//   padding: 0;
//   font-weight: 400;
// }
// /**带有二级菜单的一级菜单选中状态 */
// .el-menu--horizontal > div > .el-submenu.is-active .el-submenu__title {
//   font-size: 20px; /*px*/
//   font-weight: 500 !important;
//   background:#003863 !important;
// }
// /*导航条不带有二级菜单鼠标滑动*/
// .el-menu--horizontal > div > .el-menu-item:focus,
// .el-menu--horizontal > div > .el-menu-item:hover {
//   outline: 0;
//   font-weight: 500;
//   background: transparent;
// }
// // .el-menu--horizontal > div > .el-menu-item:focus {
// //   background: none !important;
// // }
// /*导航条带有二级菜单的一级菜单鼠标滑动*/
// .el-submenu__title:focus,
// .el-submenu__title:hover {
//   outline: 0;
//   background-color: transparent !important;
//   font-weight: 500;
// }
// @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
//   >>> .nav-submenu-box1 .el-menu-item {
//     text-align: center;
//     font-size: 16px;
//   }
//   >>> .nav-submenu-box1 .el-submenu {
//     text-align: center;
//   }
// }

// /deep/ .el-submenu__title {
//   color: #fff !important;
//   line-height: 24px;
// }
// /deep/ .el-submenu.is-active {
//   .el-submenu__title {
//     font-size: 22px;
//     color: #fff !important;
//     span {
//       vertical-align: bottom;
//     }
//   }
// }
// /deep/ .el-menu-item.is-active {
//   font-size: 22px;
//   color: #fff !important; // 2021-11-16日样式冲突去掉 !important z++
//   span {
//     vertical-align: bottom;
//   }
// }
// /deep/ .el-submenu__title:hover {
//   background: transparent;
// }

// /deep/ #nav-darkmenu {
//   .nav-submenu-box1 /deep/ .el-submenu__title {
//     font-family: "Avenir", Helvetica, Arial, sans-serif;
//     -webkit-font-smoothing: antialiased;
//     font-size: 20px; /*px*/
//     height: 58px !important;
//     line-height: 58px !important;
//     padding: 0;
//     font-weight: 400;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/MenuListForDark.vue